// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Fj-z","tupacHeader":"Gj-z","tupacHeader2":"Hj-z","tupacMenu":"Ij-z","tupacMenu2":"Jj-z","tupacMain":"Kj-z","tupacMain2":"Lj-z"};